'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Identify a given action.
 *
 * If the passed action is actually a function (e.g. when using the `thunk`
 * middleware) this creates a hased representation of the function body. If it
 * is a standard flux action with a type property, the type is returned.
 */
exports.default = function (action) {
  if (typeof action !== 'function') {
    return action.type;
  }

  var hash = 0;
  var string = action.toString();
  for (var i = 0; string.length > i; i += 1) {
    var value = (hash << 5) - hash + string.charCodeAt(string[i]);
    hash = value & value;
  }

  return Math.abs(hash);
};


//////////////////
// WEBPACK FOOTER
// ./~/@bd/redux-universal/lib/identifyAction.js
// module id = 1221
// module chunks = 0